import { render, staticRenderFns } from "./KBADefinitionFormGroup.vue?vue&type=template&id=51d2ab7e"
import script from "./KBADefinitionFormGroup.vue?vue&type=script&lang=js"
export * from "./KBADefinitionFormGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports